import { createReducer, on } from '@ngrx/store';

import { fetchHomeDataSuccessAction } from '@home/store/actions/home.actions';
import { HomeDataResponse } from '@shared/home-sections/entities/home-data.response';
import {
  fetchHomeItemDetailSuccessAction,
} from '@home-item-detail/store/actions/home-item-detail.actions';

export const initialState: HomeDataResponse = {} as HomeDataResponse;

export const homeDataReducer = createReducer(
  initialState,
  on(fetchHomeDataSuccessAction, (state, { response }) => response),
  on(fetchHomeItemDetailSuccessAction, (state, { response }) => {
    return { ...state, footer_operated_by: response.footer_operated_by };
  }),
);
